import { PortalRoleRanks, ProjectRoleRanks } from "./types/layout/types.js";
import _ from "lodash"

export const folderPermissions = () => {
  return {
    RESOURCE_UPLOAD: {
      id: 1,
      description: "RESOURCE_UPLOAD",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_DOWNLOAD: {
      id: 2,
      description: "RESOURCE_DOWNLOAD",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_COMMENT: {
      id: 3,
      description: "RESOURCE_COMMENT",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_SHARE: {
      id: 4,
      description: "RESOURCE_SHARE",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_STATUS_CHANGE: {
      id: 5,
      description: "RESOURCE_STATUS_CHANGE",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_MODIFY: {
      id: 6,
      description: "RESOURCE_MODIFY",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_DELETE: {
      id: 7,
      description: "RESOURCE_DELETE",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_VIEW: {
      id: 8,
      description: "RESOURCE_VIEW",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
    RESOURCE_CHANGE_PERMISSION: {
      id: 9,
      description: "RESOURCE_CHANGE_PERMISSION",
      type: "RESOURCE_TYPE_FOLDER",
      status: "ACTIVE",
    },
  };
};

const {
  RESOURCE_UPLOAD,
  RESOURCE_DOWNLOAD,
  RESOURCE_COMMENT,
  RESOURCE_SHARE,
  RESOURCE_STATUS_CHANGE,
  RESOURCE_MODIFY,
  RESOURCE_DELETE,
  RESOURCE_VIEW,
  RESOURCE_CHANGE_PERMISSION
} = folderPermissions();

export function folderRoles() {
  return {
    RESOURCE_ADMIN: {
      id: 1,
      frontendDisplayIndex:1,
      description: "Can edit, change permissions and transmit to other spaces",
      frontendName: "Full Access",
      code: "FULL_ACCESS",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_CHANGE_PERMISSION.description,
        RESOURCE_VIEW.description,
        RESOURCE_UPLOAD.description,
        RESOURCE_STATUS_CHANGE.description,
        RESOURCE_DOWNLOAD.description,
        RESOURCE_COMMENT.description,
        RESOURCE_SHARE.description,
        RESOURCE_MODIFY.description,
        RESOURCE_DELETE.description,
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
        RESOURCE_CHANGE_PERMISSION.id,
        RESOURCE_UPLOAD.id,
        RESOURCE_STATUS_CHANGE.id,
        RESOURCE_DOWNLOAD.id,
        RESOURCE_COMMENT.id,
        RESOURCE_SHARE.id,
        RESOURCE_MODIFY.id,
        RESOURCE_DELETE.id,
      ],
    },
    RESOURCE_EDITOR: {
      id: 2,
      frontendDisplayIndex:3,
      description: "Can create, upload, download & modify",
      frontendName: "Can Edit",
      code: "CAN_EDIT",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_VIEW.description,
        RESOURCE_STATUS_CHANGE.description,
        RESOURCE_DOWNLOAD.description,
        RESOURCE_COMMENT.description,
        RESOURCE_MODIFY.description,
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
        RESOURCE_STATUS_CHANGE.id,
        RESOURCE_DOWNLOAD.id,
        RESOURCE_COMMENT.id,
        RESOURCE_MODIFY.id,
      ],
    },
    RESOURCE_COMMENTER: {
      id: 3,
      frontendDisplayIndex:4,
      description: "Can comment, change status, download & view",
      frontendName: "Can Comment & Change Status",
      code: "CAN_COMMENT",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_VIEW.description,
        RESOURCE_STATUS_CHANGE.description,
        RESOURCE_DOWNLOAD.description,
        RESOURCE_COMMENT.description
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
        RESOURCE_DOWNLOAD.id,
        RESOURCE_COMMENT.id,
        RESOURCE_STATUS_CHANGE.id,
      ],
    },
    RESOURCE_DOWNLOADER: {
      id: 4,
      frontendDisplayIndex:5,
      description: "Can download & view",
      frontendName: "Can Download",
      code: "CAN_DOWNLOAD",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_VIEW.description,
        RESOURCE_DOWNLOAD.description,
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
        RESOURCE_DOWNLOAD.id,
      ],
    },
    RESOURCE_CREATOR:{
      id: 5,
      frontendDisplayIndex:2,
      description: "Can upload or create any entities",
      frontendName: "Can create",
      code: "CAN_CREATE",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_VIEW.description,
        RESOURCE_UPLOAD.description,
        RESOURCE_STATUS_CHANGE.description,
        RESOURCE_DOWNLOAD.description,
        RESOURCE_COMMENT.description,
        RESOURCE_MODIFY.description,
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
        RESOURCE_UPLOAD.id,
        RESOURCE_STATUS_CHANGE.id,
        RESOURCE_DOWNLOAD.id,
        RESOURCE_COMMENT.id,
        RESOURCE_MODIFY.id,
      ],
    },
    RESOURCE_VIEWER: {
      id: 6,
      frontendDisplayIndex:6,
      description: "Cannot edit, download or change permissions",
      frontendName: "Can View",
      code: "CAN_VIEW",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [
        RESOURCE_VIEW.description,
      ],
      permissionIds: [
        RESOURCE_VIEW.id,
      ],
    },
    RESOURCE_NO_ACCESS: {
      id: 7,
      frontendDisplayIndex:7,
      description: "Cannot view, edit, download or change permissions",
      frontendName: "No access",
      code: "NO_ACCESS",
      type: "RESOURCE_TYPE_FOLDER",
      permissions: [],
      permissionIds: [],
    },
   
  };
}

export const getPermissionConstants = () => {
  const permissions = folderRoles();
  const obj: any = {};

  Object.values(permissions).forEach((role) => {
    obj[role.code] = role.id;
  });

  return obj;
};

export function getFolderRolesArray() {
  const folderRolesData: any = folderRoles();
  const roles: any = [];
  Object.keys(folderRolesData).forEach((key) => {
    roles.push({
      ...folderRolesData[key],
      name: key,
    });
  });

  return roles;
}

export const MAX_FILE_UPLOAD_SIZE = 10 * 1024 * 1024 * 1024; // 10 GB
export const RESOURCE_TYPE_PROJECT = "RESOURCE_TYPE_PROJECT";
export const RESOURCE_TYPE_PORTAL = "RESOURCE_TYPE_PORTAL";
export const RESOURCE_TYPE_TRANSMITTAL = "RESOURCE_TYPE_TRANSMITTAL";
export const RESOURCE_TYPE_SPACE = "RESOURCE_TYPE_SPACE";

export const getPermissions = (t?: any) => {
  if (!t) {
    t = (args: string) => args;
  }
  return {
    USERS_ADD_TO_PROJECT: {
      description: t("Add users to current project"),
      id: 0,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_FROM_PROJECT: {
      description: t("Remove users from a project"),
      id: 1,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_ADD_SPACE_USERS: {
      description: t("Add User to a space"),
      id: 2,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_REMOVE_SPACE_USERS: {
      description: t("Remove User from a Space"),
      id: 3,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_VIEW_IN_PROJECT: {
      description: t("View Project Users"),
      id: 4,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    EDIT_PROJECT_INFO: {
      description: t("Edit project information"),
      id: 5,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_ADD_TO_PROJECT: {
      description: t("Add project spaces"),
      id: 6,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_DELETE_FROM_PROJECT: {
      description: t("Delete project spaces"),
      id: 7,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_EDIT: {
      description: t("Edit Project spaces"),
      id: 8,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_VIEW_IN_PROJECT: {
      description: t("View Project Spaces"),
      id: 9,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    TRANSMITTAL_CREATE: {
      description: t("Create Transmittal"),
      id: 10,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACES_ROOT_PERMISSION_CHANGE: {
      description: t("Change default Permission of Users in Space"),
      id: 11,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_VIEW_IN_PROJECT: {
      description: t("View Project Roles"),
      id: 12,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_ADD_TO_PROJECT: {
      description: t("Add Project Roles"),
      id: 13,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_EDIT_IN_PROJECT: {
      description: t("Edit Project Roles"),
      id: 14,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_CHANGE_OF_USER_IN_PROJECT: {
      description: t("Change Project role of a user"),
      id: 15,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ROLES_DELETE_IN_PROJECT: {
      description: t("Delete Project Roles"),
      id: 16,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_PROJECT_REMOVE_FORM_TEMPLATES: {
      description: t("Remove Form Templates From Project"),
      id: 17,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_PROJECT_VIEW_LIST_OF_FORM_TEMPLATES: {
      description: t("View Form Templates Added In Project"),
      id: 18,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPACE_CHANGE_SPACE_INFORMATION: {
      description: t("Change Space Information"),
      id: 19,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ADD_USERS_TO_SPACE: {
      description: t("Add Users to Space"),
      id: 20,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_REMOVE_USERS_FROM_SPACE: {
      description: t("Remove users from space"),
      id: 21,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ADD_COMPANIES_TO_SPACE: {
      description: t("Add companies to space"),
      id: 22,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_REMOVE_COMPANIES_FROM_SPACE: {
      description: t("Remove companies from space"),
      id: 23,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_CREATE_FOLDERS_SUBFOLDERS: {
      description: t("Create folders and sub folders"),
      id: 24,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_UPLOAD_FILES: {
      description: t("Upload files"),
      id: 25,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DOWNLOAD_FILES_FOLDERS: {
      description: t("Download Files/Folders"),
      id: 26,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_CREATE_FILE_PLACEHOLDERS: {
      description: t("Create File Spaceholders"),
      id: 27,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_COMMENT_ON_FILE: {
      description: t("Comment on a file"),
      id: 28,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DELETE_OWN_COMMENTS: {
      description: t("Delete own comments"),
      id: 29,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_DELETE_OTHER_COMMENTS: {
      description: t("Delete other comments"),
      id: 30,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_ASSIGN_SHARING_TO_FILE_FOLDER: {
      description: t("Assign sharing process to files/folder"),
      id: 31,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    SPACE_UNASSIGN_SHARING_TO_FILE_FOLDER: {
      description: t("Unassign sharing process to files/folder"),
      id: 32,
      status: "ACTIVE",
      type: RESOURCE_TYPE_SPACE,
    },
    PROJECT_ADD_TO_PORTAL: {
      description: t("Add projects to the portal"),
      id: 33,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PROJECT_LIST_VIEW_IN_PORTAL: {
      description: t("View all Projects List of Portal"),
      id: 34,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PROJECT_ARCHIVE_OF_PORTAL: {
      description: t("Archive projects of the portal"),
      id: 35,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    // BELOW PERMISSION DEPRECATED

    // PROJECT_INFORMATION_EDIT: {
    //   description: t("Edit Project Information"),
    //   id: 36,
    //   status: "ACTIVE",
    //   type: RESOURCE_TYPE_PORTAL,
    // },
    VIEW_ACCEPTED_COMPANIES: {
      description: t("View Accepted Companies"),
      id: 37,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_INVITED_COMPANIES: {
      description: t("View Invited Companies"),
      id: 38,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PORTAL_REMOVE_COMPANIES: {
      description: t("Remove company from the portal"),
      id: 39,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    PORTAL_ADD_COMPANIES: {
      description: t("Add company to the portal"),
      id: 40,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCEPT_COMPANIES: {
      description: t("Accept Company"),
      id: 41,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    REJECT_COMPANIES: {
      description: t("Reject Company"),
      id: 42,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_INFORMATION_OF_COMPANIES: {
      description: t("Edit Company information"),
      id: 43,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ASSIGN_PROJECT_TO_REGION: {
      description: t("Assign projects to a region"),
      id: 44,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    REMOVE_PROJECT_FROM_REGION: {
      description: t("Remove projects from a region"),
      id: 45,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_REGION: {
      description: t("Delete regions"),
      id: 46,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_REGION: {
      description: t("Create regions"),
      id: 47,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_REGION: {
      description: t("Edit regions"),
      id: 48,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_REGION: {
      description: t("View regions"),
      id: 49,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_PORTAL_ROLES: {
      description: t("Create Portal Role"),
      id: 50,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_PORTAL_ROLES: {
      description: t("Delete Portal Role"),
      id: 51,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_PORTAL_ROLES: {
      description: t("View Portal Roles"),
      id: 52,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_PORTAL_ROLES: {
      description: t("Edit Portal Roles"),
      id: 53,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_CREATE_OF_PORTAL_ENTITIES: {
      description: t("Create Status of Portal Entities"),
      id: 54,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_DELETE_OF_PORTAL_ENTITIES: {
      description: t("Delete Status of Portal Entities"),
      id: 55,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_EDIT: {
      description: t("Edit Status"),
      id: 56,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    STATUS_VIEW: {
      description: t("View Status"),
      id: 57,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_VIEW_ALL_IN_PORTAL: {
      description: t("View all users of Portal"),
      id: 58,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_ASSIGN_ROLE_TO_PROJECTS: {
      description: t("Assign users and their role to projects"),
      id: 59,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_REMOVE_ACCESS_TO_PROJECTS: {
      description: t("Remove which users can access which projects"),
      id: 60,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_ROLE_CHANGE_PORTAL: {
      description: t("Change portal role of any user(s)"),
      id: 61,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_ROLE_CHANGE_PROJECT: {
      description: t(
        "Change project roles of users in any projects of that portal"
      ),
      id: 62,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCESS_PORTAL_SETTINGS: {
      description: t("Access Portal Settings"),
      id: 63,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ACCESS_PROJECTS_PART_OF: {
      description: t("Access projects that they are part of"),
      id: 64,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CHANGE_PORTAL_INFORMATION: {
      description: t("Change Portal information"),
      id: 65,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    SPECIFIC_CREATE_FORM_FLOW: {
      description: t("Create Form Flow"),
      id: 66,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_ADD_TO_VISIBILITY: {
      description: t("Add users to project mailbox visibility"),
      id: 67,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_FROM_VISIBILITY: {
      description: t("Remove users from project mailbox visibility"),
      id: 68,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_PROJECT_SELECT_FORM_TEMPLATES: {
      description: t("Select Form Templates to be Used in Project"),
      id: 69,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPECIFIC_ACCESS_REVIEW_SETTINGS: {
      description: t("Access Review settings"),
      id: 70,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    PROJECT_ROLES_VIEW_IN_PORTAL: {
      description: t("View Project Roles in Portal"),
      id: 71,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_ORG_STRUCTURE_COMPANIES: {
      description: t("View Org Structures in Org Settings"),
      id: 72,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_ORG_STRUCTURE_COMPANIES: {
      description: t("Edit Org Structures in Org Settings"),
      id: 73,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ADD_ORG_STRUCTURE_COMPANIES: {
      description: t("Add Org Structures in Org Settings"),
      id: 74,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_ORG_STRUCTURE_COMPANIES: {
      description: t("Delete Org Structures in Org Settings"),
      id: 75,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    MANAGE_PORTAL_SUBSCRIPTION: {
      description: t("Manage Portal Subscription Settings"),
      id: 76,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_PORTAL_SUBSCRIPTION: {
      description: t("View Portal Subscription Settings"),
      id: 77,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    TRANSMITTAL_FILE_VERSION_ORIGIN_SPACE: {
      description: t("External Tab - View file version in origin space"),
      id: 78,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CREATE_COSTDATABASE: {
      description: t("Create Cost Databases"),
      id: 79,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_COSTDATABASE: {
      description: t("Delete Cost Databases"),
      id: 80,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_COSTDATABASE: {
      description: t("View Cost Databases"),
      id: 81,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_COSTDATABASE: {
      description: t("Edit Cost Databases"),
      id: 82,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_CHARGES: {
      description: t("Create Charges"),
      id: 83,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_CHARGES: {
      description: t("Delete Charges"),
      id: 84,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_CHARGES: {
      description: t("View Chargess"),
      id: 85,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_CHARGES: {
      description: t("Edit Charges"),
      id: 86,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_UNITS: {
      description: t("Create Units"),
      id: 87,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_UNITS: {
      description: t("Delete Units"),
      id: 88,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_UNITS: {
      description: t("View Units"),
      id: 89,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_UNITS: {
      description: t("Edit Units"),
      id: 90,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_CURRENCIES: {
      description: t("Create Currencies"),
      id: 91,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_CURRENCIES: {
      description: t("Delete Currencies"),
      id: 92,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_CURRENCIES: {
      description: t("View Currencies"),
      id: 93,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_CURRENCIES: {
      description: t("Edit Currencies"),
      id: 94,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_ORG_UNIT_TYPES: {
      description: t("Create Org Unit Types"),
      id: 95,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_ORG_UNIT_TYPES: {
      description: t("Delete Org Unit Types"),
      id: 96,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_ORG_UNIT_TYPES: {
      description: t("View Org Unit Types"),
      id: 97,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_ORG_UNIT_TYPES: {
      description: t("Edit Org Unit Types"),
      id: 98,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_CUSTOM_MODULES: {
      description: t("Create Custom Modules"),
      id: 99,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_CUSTOM_MODULES: {
      description: t("Delete Custom Modules"),
      id: 100,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_CUSTOM_MODULES: {
      description: t("View Custom Modules"),
      id: 101,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_CUSTOM_MODULES: {
      description: t("Edit Custom Modules"),
      id: 102,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_PROJECT_TEMPLATES: {
      description: t("Create Project Templates"),
      id: 103,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_PROJECT_TEMPLATES: {
      description: t("Delete Project Templates"),
      id: 104,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_PROJECT_TEMPLATES: {
      description: t("View Project Templates"),
      id: 105,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_PROJECT_TEMPLATES: {
      description: t("Edit Project Templates"),
      id: 106,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_FORM_TEMPLATES: {
      description: t("Create Form Templates"),
      id: 107,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_FORM_TEMPLATES: {
      description: t("Delete Form Templates"),
      id: 108,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_FORM_TEMPLATES: {
      description: t("View Form Templates"),
      id: 109,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_FORM_TEMPLATES: {
      description: t("Edit Form Templates"),
      id: 110,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_REVIEW_FLOWS_CHECKLIST: {
      description: t("Create Review Flows Checklist"),
      id: 111,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_REVIEW_FLOWS_CHECKLIST: {
      description: t("Delete Review Flows Checklist"),
      id: 112,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_REVIEW_FLOWS_CHECKLIST: {
      description: t("View Review Flows Checklist"),
      id: 113,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_REVIEW_FLOWS_CHECKLIST: {
      description: t("Edit Review Flows Checklist"),
      id: 114,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CREATE_GROUPS: {
      description: t("Create Groups"),
      id: 115,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_GROUPS: {
      description: t("Delete Groups"),
      id: 116,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_GROUPS: {
      description: t("View Groups"),
      id: 117,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_GROUPS: {
      description: t("Edit Groups"),
      id: 118,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    VIEW_LIST_OF_ORG_USERS_COMPANIES: {
      description: t("View list of org users"),
      id: 119,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CONFIGURATION_PROJECT_SELECT_CURRENCY: {
      description: t("Select Currency To Be Used In Project"),
      id: 120,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_VIEW_LIST_OF_LOCATIONS: {
      description: t("View List of Locations"),
      id: 121,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_ADD_LOCATION: {
      description: t("Add locations"),
      id: 122,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    SPECIFIC_CREATE_MAILS: {
      description: t("Create Mails"),
      id: 123,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_EDIT_LOCATION: {
      description: t("Edit Locations"),
      id: 124,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_DELETE_LOCATION: {
      description: t("Delete Locations"),
      id: 125,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    VIEW_LIST_OF_PROJECT_WBS_ITEMS: {
      description: t("View List of WBS Items"),
      id: 126,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_VIEW_LIST_OF_TEAMS: {
      description: t("View List Of Teams"),
      id: 127,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_ADD_TEAMS: {
      description: t("Add Teams"),
      id: 128,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_DEACTIVATE_USERS: {
      description: t("Deactivate Users"),
      id: 129,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_ACTIVATE_USERS: {
      description: t("Activate Users"),
      id: 130,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_EDIT_TEAMS: {
      description: t("Edit Teams"),
      id: 131,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_DELETE_TEAMS: {
      description: t("Delete Teams"),
      id: 132,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_ADD_PROJECT_GROUPS: {
      description: t("Add Groups"),
      id: 133,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_REMOVE_PROJECT_GROUPS: {
      description: t("Remove Groups"),
      id: 134,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    USERS_VIEW_LIST_OF_PROJECT_GROUPS: {
      description: t("View List of Groups"),
      id: 135,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    ADD_PROJECT_WBS_ITEMS: {
      description: t("Add WBS Items"),
      id: 136,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    EDIT_PROJECT_WBS_ITEMS: {
      description: t("Edit WBS Items"),
      id: 137,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    DELETE_PROJECT_WBS_ITEMS: {
      description: t("Delete WBS Items"),
      id: 138,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    PROJECT_USERS_VIEW_IN_PORTAL: {
      description: t("View Project users in portal"),
      id: 139,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },

    VIEW_LIST_OF_ACCESS_TEMPLATES: {
      description: t("View List of Access Templates"),
      id: 140,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    ADD_ACCESS_TEMPLATES: {
      description: t("Add Access Templates"),
      id: 141,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    EDIT_ACCESS_TEMPLATES: {
      description: t("Edit Access Templates"),
      id: 142,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DELETE_ACCESS_TEMPLATES: {
      description: t("Delete Access Templates"),
      id: 143,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    DUPLICATE_ACCESS_TEMPLATES: {
      description: t("Duplicate Access Templates"),
      id: 144,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    CONFIGURATION_VIEW_LIST_OF_ASSET_TYPES: {
      description: t("View List of Asset Types"),
      id: 145,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_ADD_ASSET_TYPES: {
      description: t("Add Asset Types"),
      id: 146,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_EDIT_ASSET_TYPES: {
      description: t("Edit Asset Types"),
      id: 147,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    CONFIGURATION_DELETE_ASSET_TYPES: {
      description: t("Delete Asset Types"),
      id: 148,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
    VIEW_PROJECT_INFO: {
      description: t("View Project Information"),
      id: 149,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PROJECT,
    },
     USERS_ADD_TO_PORTAL: {
      description: t("Add Users to Portal"),
      id: 150,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
    USERS_EDIT_OF_PORTAL: {
      description: t("Edit Portal Users"),
      id: 151,
      status: "ACTIVE",
      type: RESOURCE_TYPE_PORTAL,
    },
  }
};

export const getPermissionNames = () => {
  const permissions = getPermissions();
  const obj: any = {};

  Object.keys(permissions).forEach((key: string) => {
    obj[key] = key;
  });
  return obj;
};

const transmittalsBaseColumns = [
  "indexAtProjectLevel",
  "subject",
  "from",
  "toSpaceIds",
  "createdBy",
  "createdDate",
];

const jiraBaseColumns = ["type", "jiraTicketKey", "summary", "portalName", "organizationName", "source", "createdBy", "createdOn", "status"];

export const defaultFormTypes = [
  "INSPECTION",
  "PROGRESS_UPDATES",
  "BILLS",
  "CHANGE_ORDER",
  "PAYMENTS",
];

export const transmittalsDefaultViews = (t?: any) => {
  if (!t) {
    t = ((args: string) => args)
  }
  return [
    {
      isShared: false,
      resourceType: "TRANSMITTALS",
      name: t("All Transmittals"),
      code: "ALL_TRANSMITTALS",
      data: {
        columns: transmittalsBaseColumns,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "TRANSMITTALS",
      name: t("Sent by me"),
      code: "SENT_BY_ME_TRANSMITTALS",
      data: {
        columns: transmittalsBaseColumns,
        filters: [
          {
            field: "createdById",
            operator: "equal",
            value: "CURRENT_USER",
          },
        ],
      },
      isDefault: true,
    }];
};

export const assetsDefaultViews = () => {
  return [
    {
      isShared: false,
      resourceType: "ASSETS",
      name: "All Assets",
      code: "ALL_Assets",
      data: {
        columns: ["_checkbox_selector", "assetId", "name", "description", "type"],
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "ASSETS",
      name: "Grouped by Type",
      code: "Grouped_by_Type",
      data: {
        groupConditions: [
          {
            column: "type",
            direction: "asc",
          }
        ],
      },
      isDefault: true,
    }
  ]
}

export const jiraDefaultViews = (t?: any) => {
  if (!t) {
    t = (args: string) => args;
  }

  return [
    {
      isShared: false,
      resourceType: "JIRA",
      name: t("All Tickets"),
      code: "ALL_TICKETS",
      data: {
        columns: jiraBaseColumns,
        filters: {
          createdBy: "createdByPortalUsers",
        },
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "JIRA",
      name: t("Created by me"),
      code: "CREATED_BY_ME",
      data: {
        columns: jiraBaseColumns,
        filters: {
          createdBy: "createdByMe",
        },
      },
      isDefault: true,
    },
  ];
};

export const getFormsView = (resourceType: any, t?: any) => {
  if (!t) {
    t = (args: string) => args;
  }
  return {
    isShared: false,
    resourceType: resourceType,
    data: {
      filterSettings: [],
      sortSettings: [],
      columnChooser: [],
    },
    name: t("Default view"),
    code: "DEFAULT_VIEW",
    isDefault: true,
  };
};

export const formsDefaultViews = (t?: any) =>
  defaultFormTypes.map((type) => getFormsView(type, t));

export const filesDefaultViews = (t?: any) => {
  if (!t) {
    t = ((args: string) => args)
  }
  return [
    {
      isShared: false,
      resourceType: "FILES",
      name: t("All Files"),
      code: "ALL_FILES",
      data: {
        enableGrouping: false,
        enableFiltering: false,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("With Review Details"),
      code: "WITH_REVIEW_DETAILS",
      data: {
        showReviewColumns: true,
        enableGrouping: false,
        enableFiltering: false,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("Unique Files Grouped"),
      code: "UNIQUE_FILES_GROUPED",
      data: {
        group: ["fileId"],
        enableGrouping: true,
        enableFiltering: true,
        enableAllVersions: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "FILES",
      name: t("Unique Files Grouped with Review Details"),
      code: "UNIQUE_FILES_GROUPED_WITH_REVIEW",
      data: {
        group: ["fileId"],
        showReviewColumns: true,
        enableGrouping: true,
        enableFiltering: true,
        enableAllVersions: true,
      },
      isDefault: true,
    },
  ];
};

export const mailboxDefaultViews = (t?: any) => {
  if (!t) {
    t = ((args: string) => args)
  }
  return [
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("All Mails"),
      code: "ALL_MAILS",
      data: {
        visibility: true,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("Sent"),
      code: "SENT",
      data: {
        visibility: false,
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "MAILBOX",
      name: t("Externally Forwarded"),
      code: "EXTERNAL",
      data: {
        visibility: false,
        disableVisibility: true,
      },
      isDefault: true,
    },
  ];
};

export const viewerDefaultViews = (t?: any) => {
  if (!t) {
    t = ((args: string) => args)
  }
  return [
    {
      isDefault: true,
      resourceType: "VIEWER",
      name: t("Default Layout"),
      code: "DEFAULT_LAYOUT",
      isShared: false,
    },
  ];
};


export const issuesDefaultView = (t?: any) => {
  if (!t) {
    t = ((args: string) => args)
  }
  return [
    {
      isShared: false,
      resourceType: "ISSUES",
      code: "CREATED_BY_ME",
      name: t("Created by me"),
      data: {
        queryConditions:
        {
          createdByName: {
            field: "createdByName",
            operator: "equal",
            value: "CURRENT_USER",
          }
        },
      },
      isDefault: true,
    },
    {
      isShared: false,
      resourceType: "ISSUES",
      name: t("Assigned to me"),
      code: "ASSIGNED_TO_ME",
      data: {
        queryConditions:
        {
          assignedToUserName: {
            field: "assignedToUserName",
            operator: "equal",
            value: "CURRENT_USER",
          }
        },
      },
      isDefault: true,
    },

    {
      isShared: false,
      resourceType: "ISSUES",
      data: {
        enableSorting: true,
        sortConditions: [],
      },
      name: t("All Issues"),
      code: "DEFAULT_VIEW",
      isDefault: true,
    },

  ];

};
export const getDefaultViewDisplayName = (item: any, t: any) => {
  if (!t) t = (args: string) => args;
  if (!item?.isDefault) return item?.name;

  const defaultViewsMap: any = {
    TRANSMITTALS: () => transmittalsDefaultViews(t),
    FILES: () => filesDefaultViews(t),
    MAILBOX: () => mailboxDefaultViews(t),
    VIEWER: () => viewerDefaultViews(t),
    INSPECTION: () => formsDefaultViews(t),
    PROGRESS_UPDATES: () => formsDefaultViews(t),
    BILLS: () => formsDefaultViews(t),
    CHANGE_ORDER: () => formsDefaultViews(t),
    PAYMENTS: () => formsDefaultViews(t),
    JIRA: () => jiraDefaultViews(t),
    ISSUES: () => issuesDefaultView(t)

  };

  const getViews = defaultViewsMap[item.resourceType];
  if (!getViews) return item?.name;

  const defaultViews = getViews();
  const defaultView = defaultViews.find((view: any) => view.code === item.code);
  return defaultView ? defaultView.name : item.name;
};

export const getPermissionIdDescriptionMapper = (t: any) => {
  const permissions: any = getPermissions(t);
  const obj: any = {};

  Object.keys(permissions).forEach((key) => {
    const permission = permissions[key];
    obj[permission.id] = permission.description;
  });
  return obj;
};

const setDeep = (obj: any, path: any, value: any) => {
  // sonar-disable-next-line
  const parts = path.replace(/\[(\d+)\]/g, ".$1").split(".");
  const lastIndex = parts.length - 1;
  let current = obj;

  parts.forEach((part: string, index: number) => {
    if (index === lastIndex) {
      current[part] = parseValue(value);
      return;
    }


    current[part] = current[part] || (isNumeric(parts[index + 1]) ? [] : {});
    current = current[part];
  });
};

const parseValue = (value: any) => {
  const stringValue = String(value);
  if (stringValue === "null") return null;
  if (stringValue === "true") return true;
  if (stringValue === "false") return false;
  if (
    !Number.isNaN(Number(value)) &&
    value !== "" &&
    typeof value === "string"
  ) {
    return Number(value);
  }
  return value;
};

const isNumeric = (str: string) => /^\d+$/.test(str);

export const convertQueryToPostPayload = (req: any) => {
  const query: any = req.query
  const result = {};
  for (const key in query) {
    setDeep(result, key, query[key]);
  }
  req.body = result;
  req.params = result;
  return result;
};

export const SECTION_TYPE_REFERENCE = "SECTION_TYPE_REFERENCE";
export const SECTION_TYPE_FORM = "SECTION_TYPE_FORM";
export const SECTION_TYPE_TASK = "SECTION_TYPE_TASK";
export const SECTION_TYPE_MILESTONE = "SECTION_TYPE_MILESTONE";
export const SECTION_TYPE_QUANTITY = "SECTION_TYPE_QUANTITY";
export const SECTION_TYPE_TABLE_SECTION = "SECTION_TYPE_TABLE_SECTION";
export const SECTION_TYPE_WBS_ITEMS = "SECTION_TYPE_WBS_ITEMS";
export const SECTION_TYPE_SUMMARY_OF_CHANGES =
  "SECTION_TYPE_SUMMARY_OF_CHANGES";
export const SECTION_TYPE_REVIEWS = "SECTION_TYPE_REVIEWS";
export const SECTION_TYPE_INSPECTION = "SECTION_TYPE_INSPECTION";
export const SECTION_TYPE_PROGRESS_UPDATES = "SECTION_TYPE_PROGRESS_UPDATES";
export const SECTION_TYPE_BILLS = "SECTION_TYPE_BILLS";
export const SECTION_TYPE_CHANGE_ORDERS = "SECTION_TYPE_CHANGE_ORDERS";
export const SECTION_TYPE_BLANK_SECTION = "SECTION_TYPE_BLANK_SECTION";
export const SECTION_TYPE_PRESET_SECTION = "SECTION_TYPE_PRESET_SECTION";
export const SECTION_TYPE_SECTION_FROM_LIBRARY =
  "SECTION_TYPE_SECTION_FROM_LIBRARY";
export const SECTION_TYPE_CUSTOM_MODULES = "SECTION_TYPE_CUSTOM_MODULES";

export const debounceDelay = 300

export const formCategories = {
  inspection: "INSPECTION",
  progressUpdates: "PROGRESS_UPDATES",
  changeOrder: "CHANGE_ORDER",
  payments: "PAYMENTS",
  mailBox: "MAILBOX",
  bills: "BILLS",
  issues: "ISSUES",
  projects: "PROJECTS",
  files: "FILES",
  contract: "CONTRACT",
  model: "MODEL",
  reviews: "REVIEWS",
  transmittal: "TRANSMITTAL",
  assets: "ASSET_REGISTER",
  assetsProject: "ASSET_REGISTER_PROJECT",
  drawing: "DRAWING"
};

export const presetSectionsCodeObject: any = {
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_TABLE_SECTION,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_CHANGE_ORDERS,
};

export const libraryEntities = {
  FORM_FLOW: "FORM_FLOW",
  TEMPLATE_SECTION: "TEMPLATE_SECTION",
};
export const getProjectMailThreadsPageUrl = (
  projectId: string,
  mailId: string
) => `/project/${projectId}/mails/${mailId}/mailThread?projectId=${projectId}`;

export function getDistanceInMeters({ pos1, pos2 }: any) {
  if (!pos1 || !pos2) {
    return 0;
  }
  const toRad = (deg: any) => (deg * Math.PI) / 180;

  const R = 6371000; // Radius of Earth in meters
  const lat1 = toRad(pos1.lat);
  const lat2 = toRad(pos2.lat);
  const deltaLat = toRad(pos2.lat - pos1.lat);
  const deltaLng = toRad(pos2.lng - pos1.lng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) *
    Math.cos(lat2) *
    Math.sin(deltaLng / 2) *
    Math.sin(deltaLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}
export const recordStatus = {
  ACTIVE: 0,
  ARCHIVED: 1,
  DELETED: 2,
} as const;

export const projectSpaceActiveStatusCheck = {
  "project.recordStatus": recordStatus.ACTIVE,
  "space.recordStatus": recordStatus.ACTIVE,
} as const;

export const clashVisibilityOptions: any = {
  XRAY_MODE: "XRAY_MODE",
  HIDE_NON_CLASHING: "HIDE_NON_CLASHING",
  SHOWALL: "SHOWALL",
};

export const cubeParams = [
  "CUBE Name",
  "CUBE Volume",
  "CUBE Area",
  "Quantity",
  "Unit",
];

export const getZohoBackendUrl = () => process.env.REACT_APP_ZOHO_BACKEND_URL;

export const streamingModeMap = {
  All: "All",
  Interactive: "Interactive",
  OnDemand: "On Demand",
};

export const objectTreeSupportedExtension = [
  "rvt",
  "nwd",
  "ifc",
  "ifczip",
  "rfa",
];

export const selectionSetSupportedExtension = [
  "rvt",
  "nwd",
  "ifc",
  "ifczip",
  "rfa",
  "dwg",
  "fbx",
];

export const RC_MENU_ITEMS = {
  ISOLATE: "Isolate",
  FOCUS: "Focus",
  HIDE: "Hide",
  ON_DEMAND_LOAD: "onDemandLoad",
  OVERRIDE: "Override",
  TRANSFORM: "Transform",
  SCALE: "Scale",
  COLOR: "Color",
  SET_COLOR: "Set Color",
  MODIFY_COLOR: "Modify Color",
  TRANSPARENCY: "Transparency",
  SELECTION: "Selection",
  RESET: "Reset",
  FILE: "File",
  ELEMENT: "Element",
  SHOW_ALL: "Show All",
  PROPERTIES: "Properties",
  PARENT: "Parent",
  GRAND_PARENT: "Grand Parent"
};
export const preExistingModules = [
  "Inspections",
  "Bills",
  "Progress Updates",
  "General Forms",
  "Permit To Work",
  "Change Orders",
  "Estimates",
  "Schedules",
  "Files",
  "Transmittals",
  "Tasks",
  "Spaces",
  "Reviews",
  "Issues",
  "Mailbox",
  "Clash",
  "Contracts",
  "Risk Management",
  "Payments",
  "Tenders",
  "Asset Register",
  "Procurement",
  "Projects",
  "Model",
];
export const PROJECT = "project"
export const DEFAULT_CALENDAR_NAME = "Default CUBE Calendar"
export const PROJECT_CALENDAR = "PROJECTCALENDAR"
export const portalRoleRanks: PortalRoleRanks = {
  PORTAL_SUPER_ADMIN: 1,
  PORTAL_ADMIN: 2,
  PORTAL_MEMBER: 3,
  CUSTOM_PORTAL_ROLE: 4
}
export const projectRoleRanks: ProjectRoleRanks = {
  PROJECT_MANAGER: 1,
  PROJECT_EDITOR: 2,
  PROJECT_PARTICIPANT: 3,
  CUSTOM_PROJECT_ROLE: 4
}

export const PORTAL_FULL_SEAT = 1;
export const PORTAL_NO_SEAT = 0;
export const PORTAL_HALF_SEAT = 2;

export const CDEModulesEnabled = ["Spaces", "Tasks", "Transmittals", "Issues", "Reviews", "Meetings", "Assets"]
export const PMModulesEnabled = [
  "Files",
  "Mailbox",
  "Estimates",
  "Schedules",
  "Progress Updates",
  "Bills",
  "Change Orders",
  "Inspections",
  "Contracts"
]

export const CLASH_ADDON_CODE = "CD";
export const CUSTOM_MODULE_ADDON_CODE = "CM";
export const BIM_TAKEOFF_ADDON_CODE = "BT";
export const RATE_ANALYSIS_ADDON_CODE = "RA";
export const SIMULATION_ADDON_CODE = "4D5D";

export const ADDONS_DISPLAY_NAME = {
  [CLASH_ADDON_CODE]: "Clash Tests",
  [CUSTOM_MODULE_ADDON_CODE]: "Custom Modules",
  [BIM_TAKEOFF_ADDON_CODE]: "BIM Takeoff",
  [RATE_ANALYSIS_ADDON_CODE]: "Rate Analysis",
  [SIMULATION_ADDON_CODE]: "Simulation",
} as const;

export type AddonsDisplayNameType = keyof typeof ADDONS_DISPLAY_NAME;

export const MATERIAL = "material";
export const P6TYPE = "primaveraP6-parse";

export const getIsAddonAccess = (addonCode: string, portalData: any) => {
  const addons = _.get(portalData, "subscription.addons");
  return (
    addons == undefined ||
    addons.some((addon: any) => addon.addon_code.includes(addonCode))
  );
};

export const fileConversionStatus = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  DOWNLOADED: "DOWNLOADED",
  ERRORED: "ERRORED",
  RETRY: "RETRY",
  NOT_REQUIRED: "NOT_REQUIRED",
};

export const exportType = {
  PDF: "PDF",
  EXCEL: "EXCEL",
  P6: "primaveraP6",
  MSP: "msproject",
};

export const DOCUMENT_TYPE = {
  DOCUMENT_TYPE_MODEL_PROPERTIES: "MODEL_PROPERTIES",
  DOCUMENT_TYPE_DRAWING_PROPERTIES: "DRAWING_PROPERTIES",
  DOCUMENT_TYPE_CUSTOM_PROPERTIES: "CUSTOM_PROPERTIES",
  DOCUMENT_TYPE_QUANTITY: "QUANTITY",
  DOCUMENT_TYPE_ASSETDATA: "ASSETDATA",
};
export const defaultModulesMapper: any = {
  INSPECTION: "INSPECTION",
  PROGRESS_UPDATES: "PROGRESS_UPDATES",
  BILLS: "BILLS",
  CHANGE_ORDER: "CHANGE_ORDER",
  CONTRACTS: "CONTRACTS",
  SCHEDULES: "SCHEDULES",
  ESTIMATES: "ESTIMATES",
  MAILBOX: "MAILBOX",
  FILES: "FILES",
  CLASH: "CLASH",
  REVIEWS: "REVIEWS",
  TRANSMITTALS: "TRANSMITTALS",
  ISSUES: "ISSUES",
  TASKS: "TASKS",
  FOLDERS: "FOLDERS",
  SPACES: "SPACES",
  ASSETS: "ASSETS"
}
const resourceRoles = folderRoles();
const fullAccessObj = {
  canCreate: true,
  role: resourceRoles.RESOURCE_ADMIN.id,
  permissions: resourceRoles.RESOURCE_ADMIN.permissionIds,
};
const canEditObj = {
  canCreate: true,
  role: resourceRoles.RESOURCE_EDITOR.id,
  permissions: resourceRoles.RESOURCE_EDITOR.permissionIds,
};
export const canViewObj = {
  canCreate: false,
  role: resourceRoles.RESOURCE_VIEWER.id,
  permissions: resourceRoles.RESOURCE_VIEWER.permissionIds,
};
export const canDownloadObj = {
  canCreate: true,
  role: resourceRoles.RESOURCE_DOWNLOADER.id,
  permissions: resourceRoles.RESOURCE_DOWNLOADER.permissionIds,
};
export const noAccessObj = {
  canCreate: false,
  role: resourceRoles.RESOURCE_NO_ACCESS.id,
  permissions: resourceRoles.RESOURCE_NO_ACCESS.permissionIds,
};
export const noAccessPermissions: any = {
  FOLDERS: {
    ...noAccessObj,
  },
  FILES: {
    ...noAccessObj,
  },
  TASKS: {
    ...noAccessObj,
  },
  ISSUES: {
    ...noAccessObj,
  },
  CONTRACTS: {
    ...noAccessObj,
  },
  ESTIMATES: {
    ...noAccessObj,
  },
  SCHEDULES: {
    ...noAccessObj,
  },
  REVIEWS: {
    ...noAccessObj,
  },
  CLASH: {
    ...noAccessObj,
  },
  TRANSMITTALS: {
    ...noAccessObj,
  },
  INSPECTION: {
    ...noAccessObj,
  },
  PROGRESS_UPDATES: {
    ...noAccessObj,
  },
  BILLS: {
    ...noAccessObj,
  },
  CHANGE_ORDER: {
    ...noAccessObj,
  },
  ASSETS: {
    ...noAccessObj,
  },
};
export const managerDefaultPermissions: any = {
  FOLDERS: {
    ...fullAccessObj,
  },
  FILES: {
    ...fullAccessObj,
  },
  TASKS: {
    ...fullAccessObj,
  },
  ISSUES: {
    ...fullAccessObj,
  },
  CONTRACTS: {
    ...fullAccessObj,
  },
  ESTIMATES: {
    ...fullAccessObj,
  },
  SCHEDULES: {
    ...fullAccessObj,
  },
  REVIEWS: {
    ...canViewObj,
    canCreate: true
  },
  CLASH: {
    ...fullAccessObj,
  },
  TRANSMITTALS: {
    ...fullAccessObj,
  },
  INSPECTION: {
    ...canDownloadObj,
  },
  PROGRESS_UPDATES: {
    ...canDownloadObj,
  },
  BILLS: {
    ...canDownloadObj,
  },
  CHANGE_ORDER: {
    ...canDownloadObj,
  },
  ASSETS: {
    ...fullAccessObj,
  },
};
export const editorDefaultPermissions: any = {
  ...noAccessPermissions,
  FOLDERS: {
    ...canEditObj,
  },
  FILES: {
    ...canEditObj,
  }
}
export const viewerDefaultPermissions: any = {
  ...noAccessPermissions,
  FOLDERS: {
    ...canViewObj,
  },
  FILES: {
    ...canViewObj,
  }
}